import { Box } from '@mui/material';
import React from 'react';
import theme from '../../theme';
import Text from './Text';

const styles = {
  text: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
};

type Props = {
  children: React.ReactNode;
};

const Description: React.FC<Props> = ({ children }) => {
  return (
    <Box sx={styles.text}>
      <Text size="medium" color="#4D525B" mv={3}>
        {children}
      </Text>
    </Box>
  );
};

export default Description;
